import React, { useContext } from "react";
import BackContinueButton from "../backContinueButton";
import commonContext from "../../../context/common";

const FinalSubmit: React.FC = () => {
    const { utils, lead, base } = useContext(commonContext);
    return (
        <>
            <div className="container mx-auto px-5">
                <div className="relative w-full my-8">
                    {base == "zd-10-seconds" || base == "dd-al" ? (
                        <>
                            <p className="oncost-text openSans-SemiBold text-xl sm:text-xl md:text-2xl mr-3 md:mr-4 mr-5 w-full">
                                Total On-road Cost
                            </p>
                            <div className="w-full">
                                <span className="font-42px leading-normal oncost-text WebRupee">
                                    Rs.
                                </span>
                                <p className="openSans-SemiBold font-42px leading-normal oncost-text ml-2 inline-block">
                                    {utils.currencyFormat(
                                        (lead.avgCost
                                            ? parseInt(lead.avgCost)
                                            : 0) -
                                            (lead.discountPrice
                                                ? parseInt(lead.discountPrice)
                                                : 0) +
                                            (lead.roadTaxInsuranceAvailed
                                                ? parseInt(lead.rtoEditAmount)
                                                : 0) +
                                            (lead.motorInsuranceAvailed
                                                ? lead.motorInsurancePremium
                                                    ? parseFloat(
                                                          lead.motorInsurancePremium
                                                      )
                                                    : parseFloat(
                                                          lead.motorInsurancePremAmt
                                                      )
                                                : 0) +
                                            (lead.dealerInsuranceAvailed
                                                ? parseInt(
                                                      lead.dealerInsuranceAmtEdit
                                                  )
                                                : 0)
                                    )}
                                </p>
                            </div>
                        </>
                    ) : (
                        ""
                    )}
                </div>
                <BackContinueButton backPath="/offer" />
            </div>
        </>
    );
};

export default FinalSubmit;
